Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    bp = _STYLES$useStyles.bp,
    colors = _STYLES$useStyles.colors,
    COLORS = _STYLES$useStyles.COLORS,
    fontSemiBold = _STYLES$useStyles.fontSemiBold;
  var container = {
    width: '100%',
    flexDirection: 'row',
    maxWidth: _styles.STYLES.grid.maxTextWidth,
    alignSelf: 'center'
  };
  if (bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal])) {
    container.flexDirection = 'column';
    container.gap = (0, _styles.getREM)(1);
  }
  var linkContainer = {
    display: 'flex',
    flex: 1
  };
  if (bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal])) {
    linkContainer.flex = undefined;
  }
  var linkText = Object.assign({}, fontSemiBold, {
    textDecorationLine: 'none',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: (0, _styles.getREM)(0.25),
    paddingTop: (0, _styles.getREM)(1),
    paddingBottom: (0, _styles.getREM)(0.75),
    paddingLeft: (0, _styles.getREM)(0.25),
    paddingRight: (0, _styles.getREM)(0.25),
    color: colors.brand,
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s,
    textAlign: 'center',
    height: '100%',
    alignItems: 'center'
  });
  var linkText_pointerOver = {
    color: COLORS.cherry
  };
  var linkLine = {
    width: '100%',
    backgroundColor: COLORS.steam,
    height: (0, _styles.getREM)(0.1875),
    marginVertical: (0, _styles.getREM)(0.09375),
    position: 'absolute',
    zIndex: 0,
    top: '100%',
    left: 0,
    right: 0,
    transform: [{
      translateY: (0, _styles.getREM)(0.25)
    }]
  };
  var linkLine_active = {
    backgroundColor: colors.brand,
    height: (0, _styles.getREM)(0.375),
    borderRadius: (0, _styles.getREM)(0.375),
    marginVertical: 0
  };
  var linkLine_pointerOver = {
    backgroundColor: COLORS.cherry,
    height: (0, _styles.getREM)(0.375),
    borderRadius: (0, _styles.getREM)(0.375),
    marginVertical: 0
  };
  var styles = _reactNative.StyleSheet.create({
    container: container,
    linkContainer: linkContainer,
    linkText: linkText,
    linkText_pointerOver: linkText_pointerOver,
    linkLine: linkLine,
    linkLine_active: linkLine_active,
    linkLine_pointerOver: linkLine_pointerOver
  });
  return {
    styles: styles
  };
};